export const jobOpenings = [
  {
    id: 1,
    title: "Senior Computer Vision Engineer",
    department: "Engineering",
    location: "Bangalore, India",
    type: "Full-time",
    experience: "5+ years",
    description: "Lead the development of cutting-edge computer vision solutions for enterprise clients.",
    responsibilities: [
      "Design and implement computer vision algorithms",
      "Optimize deep learning models for production",
      "Collaborate with cross-functional teams",
      "Mentor junior engineers"
    ],
    requirements: [
      "Master's degree in Computer Science or related field",
      "5+ years of experience in computer vision",
      "Strong proficiency in Python, TensorFlow, PyTorch",
      "Experience with OpenCV and image processing"
    ]
  },
  {
    id: 2,
    title: "AI/ML Research Scientist",
    department: "Research & Development",
    location: "Bangalore, India",
    type: "Full-time",
    experience: "3-7 years",
    description: "Conduct research and develop innovative AI/ML solutions for real-world applications.",
    responsibilities: [
      "Research and develop novel AI algorithms",
      "Publish research papers in top-tier conferences",
      "Prototype and validate new AI solutions",
      "Collaborate with product teams on implementation"
    ],
    requirements: [
      "PhD or Master's in AI/ML or related field",
      "Strong publication record",
      "Experience with deep learning frameworks",
      "Excellent problem-solving skills"
    ]
  },
  {
    id: 3,
    title: "Full Stack Developer",
    department: "Engineering",
    location: "Bangalore, India",
    type: "Full-time",
    experience: "3-5 years",
    description: "Build scalable web applications integrating AI/ML capabilities.",
    responsibilities: [
      "Develop responsive web applications",
      "Integrate AI/ML models into production systems",
      "Design and implement RESTful APIs",
      "Ensure application performance and security"
    ],
    requirements: [
      "Bachelor's degree in Computer Science",
      "3+ years of full-stack development experience",
      "Proficiency in React, Node.js, and databases",
      "Experience with cloud platforms (AWS preferred)"
    ]
  },
  {
    id: 4,
    title: "IoT Solutions Architect",
    department: "Solutions",
    location: "Bangalore, India",
    type: "Full-time",
    experience: "5+ years",
    description: "Design and implement end-to-end IoT solutions for industrial applications.",
    responsibilities: [
      "Architect IoT solutions for clients",
      "Design sensor integration strategies",
      "Implement edge computing solutions",
      "Lead technical discussions with clients"
    ],
    requirements: [
      "Bachelor's or Master's in Engineering",
      "5+ years in IoT or embedded systems",
      "Experience with industrial sensors and protocols",
      "Knowledge of edge computing and cloud integration"
    ]
  },
  {
    id: 5,
    title: "Technical Content Writer",
    department: "Marketing",
    location: "Bangalore, India / Remote",
    type: "Full-time",
    experience: "2-4 years",
    description: "Create compelling technical content showcasing our AI and computer vision solutions.",
    responsibilities: [
      "Write technical blog posts and case studies",
      "Create product documentation and whitepapers",
      "Develop marketing content for AI solutions",
      "Collaborate with engineering and sales teams"
    ],
    requirements: [
      "Bachelor's degree in relevant field",
      "Strong technical writing skills",
      "Understanding of AI/ML concepts",
      "Experience in B2B technology marketing"
    ]
  },
  {
    id: 6,
    title: "EdTech Product Manager",
    department: "Product - PULSE",
    location: "Bangalore, India",
    type: "Full-time",
    experience: "4-6 years",
    description: "Drive product strategy and development for PULSE EdTech platform.",
    responsibilities: [
      "Define product roadmap and strategy",
      "Work with educational institutions to understand needs",
      "Manage product development lifecycle",
      "Analyze product metrics and user feedback"
    ],
    requirements: [
      "Bachelor's degree, MBA preferred",
      "4+ years of product management experience",
      "Experience in EdTech or education sector",
      "Strong analytical and communication skills"
    ]
  }
];

export const benefits = [
  {
    title: "Competitive Compensation",
    description: "Industry-leading salary packages with performance bonuses",
    icon: "DollarSign"
  },
  {
    title: "Health & Wellness",
    description: "Comprehensive health insurance for you and your family",
    icon: "Heart"
  },
  {
    title: "Learning & Development",
    description: "Continuous learning opportunities and conference sponsorships",
    icon: "GraduationCap"
  },
  {
    title: "Flexible Work",
    description: "Hybrid work model with flexible hours",
    icon: "Clock"
  },
  {
    title: "Innovation Time",
    description: "20% time for personal projects and research",
    icon: "Lightbulb"
  },
  {
    title: "Team Culture",
    description: "Collaborative environment with brilliant minds",
    icon: "Users"
  }
];

export const hiringProcess = [
  {
    step: 1,
    title: "Application Review",
    description: "We review your application and resume"
  },
  {
    step: 2,
    title: "Initial Screening",
    description: "Phone or video call with our recruiting team"
  },
  {
    step: 3,
    title: "Technical Assessment",
    description: "Problem-solving or coding assessment"
  },
  {
    step: 4,
    title: "Team Interviews",
    description: "Interviews with potential teammates and managers"
  },
  {
    step: 5,
    title: "Offer",
    description: "We extend an offer to successful candidates"
  }
];
